module.exports = __webpack_public_path__ + "img/icon_login_wx.fba4373f.png";